import React, { useCallback, useState } from "react"
import CommonTypo from "../../../components/CommonTypo"
import { Autocomplete, Box, TextField, Paper, Button } from "@mui/material"
import NewButton from "../../../components/NewButton"
import { makeStyles } from "@material-ui/core";
import _debounce from "lodash/debounce";
import palette from "../../../theme/palette";
import { pxToRem } from "../../../theme/typography";
import shape from "../../../theme/shape";
import { onboardingPlansService } from "../../../services/onboardingPlans";
import { baseEndpoints } from "../../../services/config";
import { FontAwesomeIconRender, ICON_SLECTIN_TABS } from "../../../components/IconSelectionPopOver";

const useStyles = makeStyles((theme) => ({
    selectionBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "42px",
        gap: "8px",
        borderRadius: "20px",
        border: "1px solid var(--color-border)",
        paddingTop: "8px",
        paddingRight: "24px",
        paddingBottom: "8px",
        paddingLeft: "24px",
        // "&:hover": {
        //     border: "1px solid var(--color-new-main)",
        // },
    },
    addButtonNew: {
        height: "35px",
        borderRadius: "10px !important",
        border: "1px solid var(--color-new-main) !important",
        marginBottom: "0px !important",
        padding: "15px 16px 15px 16px !important",
        background: 'transparent',
        fontSize: `${pxToRem(16)} !important`,
        fontWeight: 400,
        color: "var(--color-new-main) !important",
        "&.Mui-disabled": {
            border: "1px solid var(--color-border) !important",
            color: "var(--color-border) !important",
        }
    },
    countryCodeBox: {
        padding: "16px",
        height: "51px",
        borderRadius: "12px",
        border: "1px solid var(--color-border)",
        backgroundColor: "transparent",
        minWidth: "43%",
        maxWidth: "50%",
        outline: "none",
        marginBottom: `0px !important`,
        '& .MuiInputBase-root': {
            backgroundColor: "transparent",

        },
        '& .MuiTextField-root': {
            marginBottom: `0px !important`,
            borderRadius: '12px',
            '& .MuiOutlinedInput-root': {
                // padding: '0px'

                borderRadius: '12px !important'
            },
            '& .MuiOutlinedInput-input': {
                padding: '0px !important',
                fontSize: '16px !important',
                fontWeight: `500 !important`,
                // padding: '7px 13px 0px!important'
            },
        },

        '& .MuiAutocomplete-option': {
            fontSize: '12px'
        }
    },
}))

const getImageUrl = (imgUrl, name, iconType) => {
    if (iconType === ICON_SLECTIN_TABS.EMOJI) {
        return <span style={{
            height: "16px",
            width: "16px",
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}>{imgUrl}</span>
    }
    if (iconType === ICON_SLECTIN_TABS.ICON) {
        return <FontAwesomeIconRender selectedIcon={imgUrl} style={{
            height: "16px",
            width: "16px",
        }} />
    }
    return <img style={{ height: "16px", width: "16px" }} src={`${baseEndpoints.getImage}${imgUrl}`} alt={name} />
}

const Step3 = ({ setNextStep, setPreviousStep, setStatus, selectedPlans: propsSelectedPlans = [], setSelectedPlans, listOfImprovements, setListOfImprovements, isDarkMode = false }) => {
    const classes = useStyles()
    const [fetchedCategory, setFetchedCategory] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [addDisabled, setAddDisabled] = useState(true);
    const [selectedValueNew, setSelectedValueNew] = useState(null);
    const [activeStatusNo, setActiveStatusNo] = useState(false);
    const [activeStatus, setActiveStatus] = useState(false);
    const [userStatus, setUserStatus] = useState("");
    const getUserStatus = (status: string) => {
        if (status === "yes") {
            setActiveStatus(true);
            setActiveStatusNo(false);
        } else {
            setActiveStatus(false);
            setActiveStatusNo(true);
        }
        setUserStatus(status);
        setStatus(status)
    };
    const selectCategory = (e, newInputValue) => {
        if (newInputValue) {
            setSelectedValueNew(newInputValue)
            setAddDisabled(false)
            setFetchedCategory([])
        }
    }
    const handleChangeWithLib = (value) => {
        if (value) {
            onboardingPlansService
                .getPlansList({
                    search: value
                })
                .then((data) => {
                    // setData(data?.data)
                    // console.log("alreadyAddedList New", alreadyAddedList, listOfImprovements)
                    // if (data?.data && data?.data?.length) {
                    //     setPreFetchedCategory(data?.data.filter(it => !alreadyAddedList.includes(it.name)))
                    // } else {
                    setFetchedCategory(data?.data || [])
                    // }
                })
        }

    };
    const debounceFn = useCallback(_debounce(handleChangeWithLib, 500), []);
    const handleChangeInputValue = (e, newInputValue) => {
        setSearchValue(newInputValue);
        debounceFn(newInputValue);
    }
    return <>
        <CommonTypo size={32} fontWeight={700} color="var(--color-text-primary)" lineHeight={36}>What would you like to <br /> improve in your life? 🌱</CommonTypo>
        <Box display={"flex"} alignItems={"center"} justifyContent={"center"} flexWrap={"wrap"} sx={{
            maxHeight: '38vh',
            width: "70%",
            overflowY: 'auto',
            gap: "12px"
        }}>
            {listOfImprovements.map(it => {
                let selectedPlans = [...(propsSelectedPlans || [])]
                const found = selectedPlans.find(ite => ite.categoryId === it.categoryId)
                return <Box className={classes.selectionBox} sx={{

                    border: found ? "1px solid var(--color-new-main)" : "1px solid var(--color-border)",
                }} onClick={() => {
                    if (found) {
                        selectedPlans = selectedPlans.filter(ite => ite.categoryId !== it.categoryId)
                        setSelectedPlans(selectedPlans)
                        // const foundAlreadySelected = props.secondselectedPlans.find(ite => ite.categoryId === it.categoryId)
                        // if (foundAlreadySelected) {
                        //     // setSecondSelectedPlans([])
                        //     // setSelectedPlanOutcomes([])
                        //     // setSelectedPlanInfluences([])
                        //     // setSelectedPlanReflectives([])
                        // }
                    } else {
                        if (selectedPlans.length < 3) {
                            selectedPlans.push(it)
                            setSelectedPlans(selectedPlans)
                        }

                    }
                }}>
                    {it.iconUrl && getImageUrl(it.iconUrl, it.name, it.iconType)}
                    <CommonTypo size={16} color={isDarkMode ? 'var(--color-text-primary)' : 'var(--color-text-secondary)'}>{it.name}</CommonTypo>
                </Box>
            })}
        </Box>
        <Box display={"flex"} marginTop={"0px"} gap={"20px"} flexDirection={"row"} alignItems={"center"} justifyContent={"center"} width={"100%"}>
            <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={fetchedCategory.sort(function (a, b) {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                    return 0;
                }).map(it => ({
                    ...it,
                    label: it.name,
                }))}
                value={searchValue}
                onChange={selectCategory}
                onInputChange={handleChangeInputValue}
                sx={{

                }}
                className={classes.countryCodeBox}
                PaperComponent={({ children }) => (
                    <Paper style={{ background: "#FFF" }} sx={{
                        '&.MuiAutocomplete-option': {
                            color: "rgb(0, 0, 0)",
                            fontSize: '18px',


                        },
                        '& .MuiAutocomplete-listbox': {
                            padding: "0px",
                            '& li': {
                                padding: `16px`,
                                color: "#5E5F5E !important",
                                fontSize: "16px !important",
                                fontWeight: "400 !important",
                                lineHeight: "24px"
                            }
                        },
                    }}>{children}</Paper>
                )}
                disableClearable
                renderInput={(params) => <TextField placeholder="Need more areas to improve?" {...params} sx={{
                    marginBottom: 0,
                    fontSize: `${pxToRem(20)} !important`,
                    '.MuiTextField-root': {
                        marginBottom: 0,
                        fontSize: `${pxToRem(20)} !important`,
                        color: isDarkMode ? 'var(--color-text-primary)' : '#5E5F5E',
                        opacity: 1, /* Firefox */
                        lineHeight: '145%',
                        fontWeight: 400,
                        border: "1px solid red",
                        backgroundColor: isDarkMode ? 'var(--white-background)' : 'transparent',
                    },
                    '& .MuiInputBase-root': {
                        padding: `0 !important`,
                        backgroundColor: isDarkMode ? 'var(--white-background) !important' : 'transparent',
                    },
                    '& .MuiInputBase-input': {
                        '::placeholder': {
                            fontSize: `${pxToRem(16)} !important`,
                            color: isDarkMode ? 'var(--color-text-primary)' : 'var(--color-text-secondary)',
                            opacity: 1, /* Firefox */
                            lineHeight: '145%',
                            fontWeight: 400,
                        },
                        fontSize: `${pxToRem(16)} !important`,
                        color: isDarkMode ? 'var(--color-text-primary)' : 'var(--color-text-primary)',
                        opacity: 1, /* Firefox */
                        lineHeight: '145%',
                        fontWeight: 400,
                    },
                    '.MuiAutocomplete-endAdornment': {
                        display: 'none'
                    }

                }} />}
            />
            <Button variant={"outlined"} className={classes.addButtonNew} disabled={addDisabled} onClick={() => {
                if (selectedValueNew) {
                    try {
                        setListOfImprovements([...listOfImprovements, selectedValueNew])
                        handleChangeInputValue({}, null)
                        setFetchedCategory([])
                        setAddDisabled(false)
                        setSelectedValueNew(null)
                    } catch (error) {
                        setFetchedCategory([])
                    }

                }
            }} >Add</Button>
        </Box>
        <CommonTypo size={16} color={isDarkMode ? 'var(--color-text-primary)' : 'var(--color-text-secondary)'}>Select up to <strong>3 goals</strong></CommonTypo>

    </>
}

export default Step3